import { v4 as uuidv4 } from "uuid";
import { generateStaticQuestionId } from "../../../../../utils/goalsUtils";

export const selfAwarenessDirector = {
    "blockId": uuidv4(),
    "description": "<p>Understands self and others’ perceptions; recognize shifts needed to grow and realise potential. Embraces the growth mindset to build forward looking action plans.</p>",
    "goalId": "dynamic360Strength",
    isRequired: true,
    feedbackBasedCondition: [
        {
            answeringCondition: [
                {
                    columnValues: ["1", "2"],
                    numberOfAnswersNeeded: 3,
                },
                {
                    columnValues: ["3", "4"],
                    numberOfAnswersNeeded: 3,
                },
                {
                    columnValues: ["5", "6"],
                    numberOfAnswersNeeded: 3,
                }
            ]
        }

    ],
    allowNAOption: true,
    "questions": [
        {
            "question": "",
            "options": [
                {
                    "label": "Never",
                    "value": "1"
                },
                {
                    "label": "Rarely",
                    "value": "2"
                },
                {
                    "label": "Occasionally",
                    "value": "3"
                },
                {
                    "label": "Sometimes",
                    "value": "4"
                },
                {
                    "label": "Usually",
                    "value": "5"
                },
                {
                    "label": "Always",
                    "value": "6"
                },
                { "label": "Can't answer", "value": "0" }
            ],
            "questionDimension": "Custom Matrix",
            "type": "matrix",
            "qid": uuidv4(),
            "matrixQuestions": [
                {
                    "subCategoryId": generateStaticQuestionId("Seeks & Actions Feedback"),
                    "subCategory": "Seeks & Actions Feedback",
                    "staticQuestionId": generateStaticQuestionId("Demonstrates awareness of own strengths and development areas"),
                    "HTMLText": "<p>Demonstrates awareness of own strengths and development areas</p>",
                    "isSelected": true,
                    "text": "Demonstrates awareness of own strengths and development areas",
                    "value": uuidv4()
                },
                {
                    "subCategoryId": generateStaticQuestionId("Seeks & Actions Feedback"),
                    "subCategory": "Seeks & Actions Feedback",
                    "staticQuestionId": generateStaticQuestionId("Actively seeks candid feedback on own performance and personal impact"),
                    "HTMLText": "<p>Actively seeks candid feedback on own performance and personal impact</p>",
                    "isSelected": true,
                    "text": "Actively seeks candid feedback on own performance and personal impact",
                    "value": uuidv4()
                },
                {
                    "subCategoryId": generateStaticQuestionId("Seeks & Actions Feedback"),
                    "subCategory": "Seeks & Actions Feedback",
                    "staticQuestionId": generateStaticQuestionId("Adapts behavior based on feedback and self-reflection"),
                    "HTMLText": "<p>Adapts behavior based on feedback and self-reflection</p>",
                    "isSelected": true,
                    "text": "Adapts behavior based on feedback and self-reflection",
                    "value": uuidv4()
                },

                {
                    "subCategoryId": generateStaticQuestionId("Takes Accountability"),
                    "subCategory": "Takes Accountability",
                    "staticQuestionId": generateStaticQuestionId("Keeps commitments; is dependable and reliable"),
                    "HTMLText": "<p>Keeps commitments; is dependable and reliable</p>",
                    "isSelected": true,
                    "text": "Keeps commitments; is dependable and reliable",
                    "value": uuidv4()
                },
                {
                    "subCategoryId": generateStaticQuestionId("Takes Accountability"),
                    "subCategory": "Takes Accountability",
                    "staticQuestionId": generateStaticQuestionId("Ensures mechanisms for the team to self-monitor performance and identify performance issues"),
                    "HTMLText": "<p>Ensures mechanisms for the team to self-monitor performance and identify performance issues</p>",
                    "isSelected": true,
                    "text": "Ensures mechanisms for the team to self-monitor performance and identify performance issues",
                    "value": uuidv4()
                },
                {
                    "subCategoryId": generateStaticQuestionId("Takes Accountability"),
                    "subCategory": "Takes Accountability",
                    "staticQuestionId": generateStaticQuestionId("Shares failures and lessons learned to prevent repeated mistakes"),
                    "HTMLText": "<p>Shares failures and lessons learned to prevent repeated mistakes</p>",
                    "isSelected": true,
                    "text": "Shares failures and lessons learned to prevent repeated mistakes",
                    "value": uuidv4()
                },


                {
                    "subCategoryId": generateStaticQuestionId("Practices Courage & Resilience"),
                    "subCategory": "Practices Courage & Resilience",
                    "staticQuestionId": generateStaticQuestionId("Is honest and straightforward in interactions; has no hidden agendas"),
                    "HTMLText": "<p>Is honest and straightforward in interactions; has no hidden agendas</p>",
                    "isSelected": true,
                    "text": "Is honest and straightforward in interactions; has no hidden agendas",
                    "value": uuidv4()
                },

                {
                    "subCategoryId": generateStaticQuestionId("Practices Courage & Resilience"),
                    "subCategory": "Practices Courage & Resilience",
                    "staticQuestionId": generateStaticQuestionId("Demonstrates persistence and determination in challenging situations"),
                    "HTMLText": "<p>Demonstrates persistence and determination in challenging situations</p>",
                    "isSelected": true,
                    "text": "Demonstrates persistence and determination in challenging situations",
                    "value": uuidv4()
                },
                {
                    "subCategoryId": generateStaticQuestionId("Practices Courage & Resilience"),
                    "subCategory": "Practices Courage & Resilience",
                    "staticQuestionId": generateStaticQuestionId("Manages emotions effectively in high-pressure or frustrating situations"),
                    "HTMLText": "<p>Manages emotions effectively in high-pressure or frustrating situations</p>",
                    "isSelected": true,
                    "text": "Manages emotions effectively in high-pressure or frustrating situations",
                    "value": uuidv4()
                },

               
            ],
            "questionLabel": "Custom Matrix"
        }
    ],
    "isSelected": true,
    "type": "matrix",
    "dimension": "Self-Awareness"
}